/* eslint-disable no-unused-vars */
export enum IconNames {
    Addedtocart = "Addedtocart",
    Backicon = "Backicon",
    Barcode = "Barcode",
    Basket = "Basket",
    Basketleft = "Basketleft",
    Calendar = "Calendar",
    Checkmark = "Checkmark",
    Chevron = "Chevron",
    Clipboard = "Clipboard",
    Close = "Close",
    Discount = "Discount",
    Externallink = "Externallink",
    Facebook = "Facebook",
    Fallback = "Fallback",
    Favorites = "Favorites",
    Globe = "Globe",
    Heart = "Heart",
    Heartfull = "Heartfull",
    History = "History",
    HMFloader = "HMFloader",
    Info = "Info",
    Instagram = "Instagram",
    Linkedin = "Linkedin",
    Mail = "Mail",
    Menu = "Menu",
    OrderHistory = "OrderHistory",
    Pdf = "Pdf",
    Pencil = "Pencil",
    Plus = "Plus",
    Profile = "Profile",
    Quickorder = "Quickorder",
    Quickordertable = "Quickordertable",
    Register = "Register",
    Search = "Search",
    Serialsearch = "Serialsearch",
    Smallarrowright = "Smallarrowright",
    Trashcan = "Trashcan",
    Warning = "Warning",
    Youtube = "Youtube",
}
